module.exports = "pegasus_template/assets/tech/plain/1.png";